<template>
  <div id="lightbox">
    <img :src="imgsource" alt="" />
    <div class="lightbox__btns">
        <a  href="#" class="button prev" @click="back"><span class="icon flaticon-left-arrow"></span></a>
        <a  href="#" class="button next" @click="next"><span class="icon flaticon-right-arrow"></span></a>
    </div>
  
    <div class="lightbox__overlay" @click="close"></div>

    <!-- <span>{{ imgsource.caption }}</span> -->
  </div>
</template>

<script>
export default {
  props: ["imgsource", "close", "next", "back"],
  mounted() {
    // var overlay = document.getElementById("lightbox");
    // overlay.setAttribute(
    //   "style",
    //   "height:" +
    //     window.innerHeight +
    //     "px; " +
    //     "width:" +
    //     window.innerWidth +
    //     "px"
    // );
    // console.log(window.innerWidth);
  }
};
</script>
<style lang="scss">
#lightbox {
  position: fixed;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  .lightbox__overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    top: 0;
    left: 0;
  }
  img {
    height: 85%;
    width: auto;
    max-height: 700px;
    position: relative;
    z-index: 1;
  }
}
.lightbox__btns {
  position: absolute;
  display: flex;
  justify-content: space-between;
  z-index: 9;
  width: 95%;
  left: 0;
  right: 0;
  margin: auto;
  top: 50%;
  transform: translateY(-50%);
  direction: ltr;
  .button {
    position: relative;
    display: block;
    width: 64px;
    height: 64px;
    background-color: #01af58;
    border-radius: 50%;
    text-align: center;
    line-height: 64px;
  }
  .icon {
    display: inline-block;
    &::before {
      color: #fff;
      margin: 0;
      font-size: 2rem !important;
    }
  }
}

@media only screen and (max-width: 991px) {
  #lightbox {
    img {
      height: auto;
      width: 100%;
      max-width: 580px;
      max-height: none;
    }
  }
}
@media only screen and (max-width: 589px) {
  #lightbox {
    img {
      height: auto;
      width: 100%;
      max-width: 320px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/fun2win/CustomLightbox.vue